import {
    Component,
    ElementRef,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GridToolComponent } from '../grid-toolbar-component/grid-tool.component';

@Component({
    selector: 'app-quick-filter',
    imports: [MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './quick-filter.component.html',
})
export class QuickFilterComponent extends GridToolComponent {
    @ViewChild('searchInput')
    private searchInput?: ElementRef<HTMLInputElement>;

    input(event: Event) {
        this.gridApi?.setGridOption(
            'quickFilterText',
            (event.target as HTMLInputElement).value,
        );
    }

    /**
     * Stops Enter from submitting a parent form so the current search is kept.
     */
    preventEnterSubmit(event: Event): void {
        event.preventDefault();
    }

    clearInput() {
        if (this.searchInput) {
            this.searchInput.nativeElement.value = '';
        }
    }
}
